import { withStateHandlers } from 'recompose';

const setIsLoadingMoreStateHandler = () => val => ({ isLoadingMore: val });

const withIsLoadingMore = withStateHandlers(() => ({ isLoadingMore: false }), {
  setIsLoadingMore: setIsLoadingMoreStateHandler,
});

export default withIsLoadingMore;
